import { Flex, Image, Link as ChakraLink, Text } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import useExtension from 'src/hooks/useExtension'

export const SupportedFooter: React.FC = () => {
  const {extensionUrl} = useExtension()
  const [t] = useTranslation()
  return (
    <Flex flexDirection='column' w='100%' alignItems='center'>
      <Flex
        w='100%'
        bg='backgroundColors.50'
        flexDirection='column'
        alignItems='center'
        paddingY='30px'
        marginTop='30px'
      >
        <Text fontFamily='Mulish' fontWeight='extrabold' fontSize='14px'>
          {t('onboard.success.desktop.fifthSection.title')}
        </Text>
        <ChakraLink
          display='flex'
          flexDirection='row'
          alignItems='center'
          justifyContent='center'
          bg='gray.800'
          w='469px'
          borderRadius='60px'
          h='46px'
          marginTop='18px'
          fontFamily='Mulish'
          fontWeight='bold'
          fontSize='16px'
          color='white'
          href={extensionUrl}
          _hover={{
            textDecoration: 'none',
          }}
        >
          <Image h='21px' marginRight='8px' src='/assets/images/chrome-icon.svg' color='white' />
          {t('onboard.success.desktop.fifthSection.button')}
        </ChakraLink>
        <Link to='/home'>
          <Text
            fontFamily='Mulish'
            fontSize='14px'
            fontWeight='regular'
            textDecoration='underline'
            marginTop='12px'
            color='bluishGray.500'
          >
            {t('onboard.success.desktop.fifthSection.link')}
          </Text>
        </Link>
      </Flex>
      <Flex paddingY='24px'>
        <Text fontFamily='Mulish' fontSize='14px' fontWeight='regular'>
          {t('onboard.success.desktop.sixthSection.description')}
        </Text>
        <ChakraLink
          fontFamily='Mulish'
          fontSize='14px'
          fontWeight='regular'
          marginLeft='4px'
          textDecoration='underline'
          href='https://educationjourney.zendesk.com/'
          target='_blank'
          rel='noopener noreferrer'
        >
          {t('onboard.success.desktop.sixthSection.link')}
        </ChakraLink>
      </Flex>
    </Flex>
  )
}

export const EdgecasesFooter: React.FC = () => {
  const [t] = useTranslation()
  return (
    <Flex flexDirection='column' w='100%' alignItems='center'>
      <Flex w='100%' bg='white' flexDirection='column' alignItems='center' paddingY='30px'>
        <Text fontFamily='Mulish' fontWeight='extrabold' fontSize='14px'>
          {t('onboard.success.desktop.fifthSection.title')}
        </Text>
        <ChakraLink
          display='flex'
          flexDirection='row'
          alignItems='center'
          justifyContent='center'
          bg='gray.800'
          w='469px'
          borderRadius='60px'
          h='46px'
          marginTop='18px'
          fontFamily='Mulish'
          fontWeight='bold'
          fontSize='16px'
          color='white'
          _hover={{
            textDecoration: 'none',
          }}
          href='https://www.google.pt/intl/pt-PT/chrome/?brand=ISCS&gclid=CjwKCAiAvriMBhAuEiwA8Cs5lQ5oSWisnGAKeo-2Ygfpviat2B77YN8oJrUmpqQ-fzwUy7ewhzNvchoCkcgQAvD_BwE&gclsrc=aw.ds'
        >
          <Image h='21px' marginRight='8px' src='/assets/images/chrome-icon.svg' color='white' />
          {t('onboard.success.desktop.edgecases.chromeInstall')}
        </ChakraLink>
        <Link to='/home'>
          <Text
            fontFamily='Mulish'
            fontSize='14px'
            fontWeight='regular'
            textDecoration='underline'
            marginTop='12px'
            color='bluishGray.500'
          >
            {t('onboard.success.desktop.fifthSection.link')}
          </Text>
        </Link>
      </Flex>
      <Flex paddingY='24px'>
        <Text fontFamily='Mulish' fontSize='14px' fontWeight='regular'>
          {t('onboard.success.desktop.sixthSection.description')}
        </Text>
        <ChakraLink
          fontFamily='Mulish'
          fontSize='14px'
          fontWeight='regular'
          marginLeft='4px'
          textDecoration='underline'
          href='https://educationjourney.zendesk.com/'
          target='_blank'
          rel='noopener noreferrer'
        >
          {t('onboard.success.desktop.sixthSection.link')}
        </ChakraLink>
      </Flex>
    </Flex>
  )
}
